export default __webpack_public_path__ + "static/media/size_icon.08e2ddf5.svg";